import { useState, useCallback } from "react";
import { DataProviderInstance } from "../../../api/DataProvider";

/**
 * Estado e lógica da conversa do Simulador de Atendimento por IA.
 * A conversa existe apenas em memória: nada é enviado para pacientes reais.
 */
const useAISimulator = () => {
  const { GenerateAISimulatorReply } = DataProviderInstance();

  const [messages, setMessages] = useState([]);
  const [isGenerating, setIsGenerating] = useState(false);
  const [error, setError] = useState(null);

  const sendMessage = useCallback((text, knowledge) => {
    const content = (text || "").trim();
    if (content === "" || isGenerating) return;

    const patientMessage = { role: "patient", content, date: new Date().toISOString() };
    const history = [...messages, patientMessage];

    setMessages(history);
    setIsGenerating(true);
    setError(null);

    GenerateAISimulatorReply(
      history.map((message) => ({ role: message.role, content: message.content })),
      knowledge || "",
      (result) => {
        setIsGenerating(false);
        if (result && result.success) {
          setMessages((prev) => [
            ...prev,
            { role: "ai", content: result.reply, notes: result.notes || [], date: new Date().toISOString() },
          ]);
        } else {
          setError((result && result.error) || "Não foi possível gerar a resposta da IA. Tente novamente.");
        }
      }
    );
  }, [messages, isGenerating, GenerateAISimulatorReply]);

  const resetConversation = useCallback(() => {
    setMessages([]);
    setIsGenerating(false);
    setError(null);
  }, []);

  return { messages, isGenerating, error, sendMessage, resetConversation };
};

export default useAISimulator;
